import $ from 'jquery';


$(function () {

	/* Country selector
	********************************************/

	$('.country-selector-button').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$('.footer-selector').slideToggle(400);
		$('html, body').animate({
			scrollTop: $('.footer-selector').offset().top - 20
		}, 700);
	});

	$('a.close-selector').on('click', function(e){
		e.preventDefault();
		$('.footer-selector').slideToggle(500);
		$('.country-selector-button').removeClass('active');
	});


});
